import { useRef, useMemo, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import Reveal from '../components/Reveal';
import { useLanguage } from '../context/LanguageContext';
import { getYouTubeEmbedUrl } from '../utils/getYouTubeEmbedUrl';

const SERVICE_CARD_IMAGES = [
  'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1800&q=80',
  'https://www.housingwire.com/wp-content/uploads/2026/05/RealEstateListing.jpg',
  'https://www.propertyfinder.ae/blog/wp-content/uploads/2025/12/Untitled-design-12.png',
  'https://geauction.com/wp-content/uploads/2018/07/5-Auction-Tips-for-Beginners2.jpg',
  'https://staffordfinancialllc.com/wp-content/uploads/2024/07/b373b0f615edaa6845bc1296e5a0a121.jpg',
  'https://amsindia.co.in/wp-content/uploads/2025/01/7bb79e4693.jpg',
  'https://images.unsplash.com/photo-1618220179428-22790b461013?auto=format&fit=crop&w=1800&q=80',
  'https://cdn.financebuzz.com/images/2024/05/31/home-maintenance-repairs.jpg',
  'https://plus.unsplash.com/premium_photo-1661329930662-19a43503782f?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8bGVnYWx8ZW58MHx8MHx8fDA%3D',
  'https://images.unsplash.com/photo-1460317442991-0ec209397118?auto=format&fit=crop&w=1800&q=80',
  'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&w=1800&q=80',
  'https://images.unsplash.com/photo-1560185007-cde436f6a4d0?auto=format&fit=crop&w=1800&q=80',
  'https://images.pexels.com/photos/7723825/pexels-photo-7723825.jpeg',
  'https://www.eventbrite.com/e/_next/image?url=https%3A%2F%2Fimg.evbuc.com%2Fhttps%253A%252F%252Fcdn.evbuc.com%252Fimages%252F1181068051%252F2657937592541%252F1%252Foriginal.20260331-060846%3Fcrop%3Dfocalpoint%26fit%3Dcrop%26w%3D600%26auto%3Dformat%252Ccompress%26q%3D75%26sharp%3D10%26fp-x%3D0.5%26fp-y%3D0.5%26s%3D1568d04452e3a986c8ecb849f3d55a94&w=1880&q=75',
  'https://images.unsplash.com/photo-1517048676732-d65bc937f952?auto=format&fit=crop&w=1800&q=80',
  'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&w=1400&q=80', // feasibility
  'https://images.unsplash.com/photo-1432888498266-38ffec3eaf0a?auto=format&fit=crop&w=1400&q=80', // marketing
  'https://images.unsplash.com/photo-1529074963764-98f45c47344b?auto=format&fit=crop&w=1400&q=80', // immigration
  'https://images.unsplash.com/photo-1554224155-6726b3ff858f?auto=format&fit=crop&w=1800&q=80', // accounting & financial consulting
  'https://blog.bayut.sa/uploads/2025/06/image-1440x900-18-1024x640.jpg',
];

const DETAIL_FALLBACK_IMAGES = [
  'https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=1400&q=80',
  'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?auto=format&fit=crop&w=1400&q=80',
  'https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=1400&q=80',
  'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=1400&q=80',
  'https://gmcconsultingvn.com/wp-content/uploads/2025/04/Tu-van-phap-ly-theo-tung-vu-viec-2.jpg',
  'https://images.unsplash.com/photo-1553877522-43269d4ea984?auto=format&fit=crop&w=1400&q=80',
  'https://images.unsplash.com/photo-1600880292203-757bb62b4baf?auto=format&fit=crop&w=1400&q=80',
  'https://images.unsplash.com/photo-1444653614773-995cb1ef9efa?auto=format&fit=crop&w=1400&q=80',
];

const SERVICE_CATEGORY_IMAGES = {
  '13': [
    'https://plus.unsplash.com/premium_photo-1661771719168-449af6de4e8f?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NTN8fGNvbnRyYWN0c3xlbnwwfHwwfHx8MA%3D%3D', // asset safety / verification
    'https://saratogainvestmentcorp.com/wp-content/uploads/2020/08/money-stock-saratoga.jpg', // financial privileges
    'https://okdiario.com/metabolic/en/wp-content/uploads/2025/04/Two-men-talking-and-laughing-1.jpg', // professional accreditation
    'https://images.unsplash.com/photo-1535378917042-10a22c95931a?auto=format&fit=crop&w=1400&q=80', // PropTech / blockchain / QR
    'https://gmcconsultingvn.com/wp-content/uploads/2025/04/Tu-van-phap-ly-theo-tung-vu-viec-2.jpg', // government / legal
    'https://images.unsplash.com/photo-1579952363873-27f3bade9f55?auto=format&fit=crop&w=1400&q=80', // marketing / branding / awards
  ],
  '15': [
    'https://www.matrrix.in/images/blog/1000xnull/47916068dba38d4714a9.28333436.webp', // accredited diplomas
    'https://www.bakerhughes.com/sites/bakerhughes/files/2020-07/People%20TPS%20field%20service%20%289%29-2880x1920.jpg', // smart real estate tech
    'https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=1400&q=80', // leadership & soft skills
    'https://gmcconsultingvn.com/wp-content/uploads/2025/04/Tu-van-phap-ly-theo-tung-vu-viec-2.jpg', // legal & financial
    'https://images.unsplash.com/photo-1504307651254-35680f356dfd?auto=format&fit=crop&w=1400&q=80', // field development
    'https://images.unsplash.com/photo-1432888498266-38ffec3eaf0a?auto=format&fit=crop&w=1400&q=80', // e-learning / digital
    'https://images.unsplash.com/photo-1542744173-8e7e53415bb0?auto=format&fit=crop&w=1400&q=80', // corporate services
  ],
  '12': [
    'https://images.unsplash.com/photo-1560518883-ce09059eeffa?auto=format&fit=crop&w=1400&q=80', // landlord services
    'https://images.unsplash.com/photo-1600585154526-990dced4db0d?auto=format&fit=crop&w=1400&q=80', // tenant services
    'https://images.unsplash.com/photo-1681505531034-8d67054e07f6?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8Y29udHJhY3RzfGVufDB8fDB8fHww', // legal & contracts
    'https://images.unsplash.com/photo-1497366811353-6870744d04b2?auto=format&fit=crop&w=1400&q=80', // commercial leasing
    'https://images.unsplash.com/photo-1579621970795-87facc2f976d?auto=format&fit=crop&w=1400&q=80', // financial solutions
    'https://images.unsplash.com/photo-1484154218962-a197022b5858?auto=format&fit=crop&w=1400&q=80', // value-added operations
  ],
  '14': [
    'https://images.unsplash.com/photo-1540575467063-178a50c2df87?auto=format&fit=crop&w=1400&q=80', // elite branding / conference
    'https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=1400&q=80', // premium pavilion / space
    'https://images.unsplash.com/photo-1515187029135-18ee286d815b?auto=format&fit=crop&w=1400&q=80', // networking / B2B
    'https://images.unsplash.com/photo-1560472355-536de3962603?auto=format&fit=crop&w=1400&q=80', // concierge / logistics
    'https://images.unsplash.com/photo-1551818255-e6e10975bc17?auto=format&fit=crop&w=1400&q=80', // event tech / AR
    'https://images.unsplash.com/photo-1579952363873-27f3bade9f55?auto=format&fit=crop&w=1400&q=80', // post-event / awards
  ],
  '20': [
    'https://images.unsplash.com/photo-1529400971008-f566de0e6dfc?auto=format&fit=crop&w=1400&q=80', // strategic planning
    'https://images.unsplash.com/photo-1486325212027-8081e485255e?auto=format&fit=crop&w=1400&q=80', // asset monetisation
    'https://lakshminirman.com/wp-content/uploads/2023/04/investor-double-exposure-image-investor-business-man-handshake-with-partner-successful-meeting-deal-with-during-sunrise-cityscape-background-investment-partnership-teamwork-concept-1536x1024.jpeg', // PPP
    'https://www.wheelhouseit.com/wp-content/uploads/2024/04/lawlap.jpeg', // legislative
    'https://images.unsplash.com/photo-1540575467063-178a50c2df87?auto=format&fit=crop&w=1400&q=80', // investment summits
    'https://images.unsplash.com/photo-1568952433726-3896e3881c65?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8dGVjaG5vbG9neXxlbnwwfHwwfHx8MA%3D%3D', // digital transformation
    'https://images.unsplash.com/photo-1469571486292-0ba58a3f068b?auto=format&fit=crop&w=1400&q=80', // sustainability
  ],
  '11': [
    'https://fa-in.com/wp-content/uploads/2019/02/InvestmentAnalysis.jpg', // portfolio strategy
    'https://images.unsplash.com/photo-1582407947304-fd86f028f716?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8cmVhbCUyMGVzdGF0ZXxlbnwwfHwwfHx8MA%3D%3D', // acquisition & sourcing
    'https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=1400&q=80', // asset management
    'https://wpblogassets.paytm.com/paytmblog/uploads/2023/09/Blog_Paytm_What-Is-a-Long-Term-Investment-and-What-Are-Its-Benefits.jpg', // financial engineering
    'https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=1400&q=80', // reporting & governance
    'https://sg.nec.com/en_SG/images/2025/NEC-financial-graph-and-digital-transformation-for-banking_1vPECq.webp', // exit strategies
  ],
  '10': [
    'https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?auto=format&fit=crop&w=1400&q=80', // proptech dashboard
    'https://images.unsplash.com/photo-1504307651254-35680f356dfd?auto=format&fit=crop&w=1400&q=80', // maintenance operations
    'https://images.unsplash.com/photo-1554224155-6726b3ff858f?auto=format&fit=crop&w=1400&q=80', // financial management
    'https://plus.unsplash.com/premium_photo-1661751188825-710ec341b907?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NDV8fEVtcGxveW1lbnQlMjAlMjYlMjBIUiUyMGxhd3xlbnwwfHwwfHx8MA%3D%3D', // tenant relations
    'https://images.unsplash.com/photo-1557804506-669a67965ba0?auto=format&fit=crop&w=1400&q=80', // security logistics
    'https://images.unsplash.com/photo-1560185007-cde436f6a4d0?auto=format&fit=crop&w=1400&q=80', // value-added services
  ],
  '04': [
    'https://images.unsplash.com/photo-1560472355-536de3962603?auto=format&fit=crop&w=1400&q=80', // pre-auction preparation
    'https://plus.unsplash.com/premium_photo-1661371731552-9a1a45bb797d?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mjd8fGF1Y3Rpb25zfGVufDB8fDB8fHww', // e-auction technology
    'https://images.unsplash.com/photo-1517048676732-d65bc937f952?auto=format&fit=crop&w=1400&q=80', // auction marketing
    'https://geauction.com/wp-content/uploads/2018/07/5-Auction-Tips-for-Beginners2.jpg',           // live auction management
    'https://mltfwbciccuo.i.optimole.com/cb:n4OZ.4d52/w:auto/h:auto/q:mauto/f:best/https://www.evalueserve.com/wp-content/uploads/2024/06/fund-finance-scaled.jpeg', // financial support
    'https://plus.unsplash.com/premium_photo-1661373146200-985b0088b8dd?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OXx8Y29udHJhY3RzfGVufDB8fDB8fHww', // post-auction
    'https://images.unsplash.com/photo-1479839672679-a46483c0e7c8?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTh8fHJlYWwlMjBlc3RhdGV8ZW58MHx8MHx8fDA%3D', // specialized formats
  ],
  '08': [
    'https://cdn.financebuzz.com/images/2024/05/31/home-maintenance-repairs.jpg',                    // preventive maintenance
    'https://images.unsplash.com/photo-1504307651254-35680f356dfd?auto=format&fit=crop&w=1400&q=80', // structural restoration
    'https://images.unsplash.com/photo-1562259949-e8e7689d7828?auto=format&fit=crop&w=1400&q=80',    // corrective maintenance
    'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?auto=format&fit=crop&w=1400&q=80',    // smart systems
    'https://images.unsplash.com/photo-1416879595882-3373a0480b5b?auto=format&fit=crop&w=1400&q=80', // environmental & logistical
    'https://images.unsplash.com/photo-1544027993-37dbfe43562a?auto=format&fit=crop&w=1400&q=80',    // emergency & assessment
  ],
  '07': [
    'https://images.unsplash.com/photo-1618220179428-22790b461013?auto=format&fit=crop&w=1400&q=80', // design concept
    'https://images.unsplash.com/photo-1600210492493-0946911123ea?auto=format&fit=crop&w=1400&q=80', // artistic finishes
    'https://images.unsplash.com/photo-1555041469-a586c61ea9bc?auto=format&fit=crop&w=1400&q=80', // bespoke furniture
    'https://images.unsplash.com/photo-1706774609219-56c61f8b3c51?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8c21hcnQlMjBob21lfGVufDB8fDB8fHww', // smart & green design
    'https://images.unsplash.com/photo-1560185007-cde436f6a4d0?auto=format&fit=crop&w=1400&q=80', // investor services
    'https://images.unsplash.com/photo-1600585154526-990dced4db0d?auto=format&fit=crop&w=1400&q=80', // logistics & delivery
  ],
  '06': [
    'https://images.unsplash.com/photo-1504307651254-35680f356dfd?auto=format&fit=crop&w=1400&q=80', // planning & pre-construction
    'https://images.unsplash.com/photo-1503387762-592deb58ef4e?auto=format&fit=crop&w=1400&q=80', // structural & civil
    'https://images.unsplash.com/photo-1618220179428-22790b461013?auto=format&fit=crop&w=1400&q=80', // fit-out & finishing
    'https://images.unsplash.com/photo-1605313294941-ea43850d9de5?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTF8fE1lY2hhbmljYWwlMkMlMjBlbGVjdHJpY2FsJTIwJTI2JTIwcGx1bWJpbmd8ZW58MHx8MHx8fDA%3D', // MEP systems
    'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?auto=format&fit=crop&w=1400&q=80', // smart building tech
    'https://images.unsplash.com/photo-1567016251318-c85cc6f139c9?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MzZ8fHJlYWwlMjBlc3RhdGV8ZW58MHx8MHx8fDA%3D', // site management & quality
  ],
  '01': [
    'https://emlakrealty.com/_next/image?url=%2Fimages%2Fbackground-image.jpg&w=2048&q=75', // buyer services
    'https://range.ae/api/media/file/6110fe1db31ef0c168eb397c442e43083f4288b1%20(1).png', // seller services
    'https://plus.unsplash.com/premium_photo-1672423156257-9a2bc5e1f480?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mzd8fHJlYWwlMjBlc3RhdGV8ZW58MHx8MHx8fDA%3D', // corporate & B2B
    'https://www.consultancy.uk/illustrations/news/spotlight/1460033138430_lawfirms.jpg', // legal & escrow
    'https://a101.com/wp-content/uploads/2023/05/insight.png', // proptech tools
    'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1400&q=80', // value-added services
  ],
  '02': [
    'https://images.unsplash.com/photo-1560520653-9e0e4c89eb11?auto=format&fit=crop&w=1400&q=80', // matching & valuation
    'https://images.unsplash.com/photo-1580587771525-78b9dba3b914?auto=format&fit=crop&w=1400&q=80', // exchange models
    'https://images.unsplash.com/photo-1579621970563-ebec7560ff3e?auto=format&fit=crop&w=1400&q=80', // financial engineering
    'https://www.consultancy.uk/illustrations/news/spotlight/1460033138430_lawfirms.jpg', // legal & escrow
    'https://images.unsplash.com/photo-1503387762-592deb58ef4e?auto=format&fit=crop&w=1400&q=80', // technical & logistical
    'https://www.microbank.com/docs/blog/1931.jpg', // VIP elite exchange
  ],
  '03': [
    'https://images.unsplash.com/photo-1681505504714-4ded1bc247e7?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8Y29udHJhY3RzfGVufDB8fDB8fHww', // financial & banking
    'https://techfundingnews.com/wp-content/uploads/2025/12/Digital-Asset-Investment-.jpg', // investment & strategic
    'https://www.consultancy.uk/illustrations/news/spotlight/1460033138430_lawfirms.jpg', // legal & judicial
    'https://images.unsplash.com/photo-1503387762-592deb58ef4e?auto=format&fit=crop&w=1400&q=80', // technical / development
    'https://plus.unsplash.com/premium_photo-1683121710572-7723bd2e235d?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MzB8fHRlY2hub2xvZ3l8ZW58MHx8MHx8fDA%3D', // proptech & smart
    'https://images.unsplash.com/photo-1623101275026-9eb1e7b4d5df?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8c2t5JTIwc2NyYXBlcnN8ZW58MHx8MHx8fDA%3D', // specialized niche
  ],
  '05': [
    'https://plus.unsplash.com/premium_photo-1661768507909-f961fcff0d45?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OXx8cGFydG5lcnNoaXB8ZW58MHx8MHx8fDA%3D', // letters of credit / international trade
    'https://www.vakifkatilim.com.tr/documents/SigortaveKurumsalCozumler/teminatmektuplari1140x760urundetay.jpg', // letters of guarantee / documents
    'https://www.evest.blog/wp-content/uploads/2024/07/shutterstock_2286572337-scaled.jpg', // trade finance advisory
    'https://images.unsplash.com/photo-1578575437130-527eed3abbec?auto=format&fit=crop&w=1400&q=80', // import/export / shipping
    'https://www.guptasen.com/wp-content/uploads/2020/09/private-money-lenders-Property-India.jpg', // risk management
    'https://plus.unsplash.com/premium_photo-1683120972279-87efe2ba252f?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MjV8fHRlY2hub2xvZ3l8ZW58MHx8MHx8fDA%3D', // digital trade finance
  ],
  '09': [
    'https://images.unsplash.com/photo-1541447271487-09612b3f49f7?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8c2t5JTIwc2NyYXBlcnN8ZW58MHx8MHx8fDA%3D', // corporate formation / office building
    'https://www.wheelhouseit.com/wp-content/uploads/2024/04/lawlap.jpeg', // real estate & construction law
    'https://images.unsplash.com/photo-1681505512385-8b9d567a56c0?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NTV8fGNvbnRyYWN0fGVufDB8fDB8fHww', // commercial contracts / handshake
    'https://portal.alnozom.sa/pluginfile.php/820/course/overviewfiles/HR.jpeg', // employment & HR law
    'https://plus.unsplash.com/premium_photo-1661329930662-19a43503782f?w=500&auto=format&fit=crop&q=60', // intellectual property / verified
    'https://images.unsplash.com/photo-1627518788331-b3b7fdaa382f?q=80&w=1025&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D', // litigation / legal documents
    'https://plus.unsplash.com/premium_photo-1694476607280-57d5dc52e766?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTd8fCVEOSU4MiVEOCVBNyVEOSU4NiVEOSU4OCVEOSU4NiUyMCVEOCVBNyVEOSU4NCVEOCVCOSVEOSU4NSVEOSU4NHxlbnwwfHwwfHx8MA%3D%3D', // private client / family office
  ],
  '16': [
    'https://insightss.co/blogs/wp-content/uploads/2024/05/image-whatsapp-Sheharyar-4.jpg',
    'https://images.unsplash.com/photo-1503387762-592deb58ef4e?auto=format&fit=crop&w=1400&q=80',
    'https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=1400&q=80',
    'https://images.unsplash.com/photo-1627327053419-fe894c4650ed?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTR8fHNreSUyMHNjcmFwZXJzfGVufDB8fDB8fHww',
    'https://www.wheelhouseit.com/wp-content/uploads/2024/04/lawlap.jpeg',
    'https://images.unsplash.com/photo-1553877522-43269d4ea984?auto=format&fit=crop&w=1400&q=80',
  ],
  '17': [
    'https://images.unsplash.com/photo-1561070791-2526d30994b5?auto=format&fit=crop&w=1400&q=80',
    'https://images.unsplash.com/photo-1611162617213-7d7a39e9b1d7?auto=format&fit=crop&w=1400&q=80',
    'https://images.unsplash.com/photo-1492691527719-9d1e07e534b4?auto=format&fit=crop&w=1400&q=80',
    'https://images.unsplash.com/photo-1517048676732-d65bc937f952?auto=format&fit=crop&w=1400&q=80',
    'https://images.unsplash.com/photo-1432888498266-38ffec3eaf0a?auto=format&fit=crop&w=1400&q=80',
    'https://images.unsplash.com/photo-1540575467063-178a50c2df87?auto=format&fit=crop&w=1400&q=80',
  ],
  '19': [
    'https://images.unsplash.com/photo-1554224155-6726b3ff858f?auto=format&fit=crop&w=1400&q=80', // accounting / bookkeeping
    'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?auto=format&fit=crop&w=1400&q=80', // taxation / charts
    'https://images.unsplash.com/photo-1434626881859-194d67b2b86f?auto=format&fit=crop&w=1400&q=80', // financial planning
    'https://www.investmentbankingcouncil.org/images/investing-in-technology.jpg', // funding & growth
    'https://www.mashvisor.com/blog/wp-content/uploads/2018/06/bigstock-Businessman-Is-Deeply-Reviewin-237430927-1.jpg', // specialized / professional
  ],
  '18': [
    'https://images.unsplash.com/photo-1504214208698-ea1916a2195a?auto=format&fit=crop&w=1400&q=80', // passport / citizenship
    'https://images.unsplash.com/photo-1512453979798-5ea266f8880c?auto=format&fit=crop&w=1400&q=80', // golden visa / Dubai skyline
    'https://images.unsplash.com/photo-1559136555-9303baea8ebd?auto=format&fit=crop&w=1400&q=80', // startup / entrepreneur
    'https://images.unsplash.com/photo-1521737604893-d14cc237f11d?auto=format&fit=crop&w=1400&q=80', // professional / skilled migration
    'https://plus.unsplash.com/premium_photo-1661496148632-514dd2197691?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mjl8fGNvbnRyYWN0c3xlbnwwfHwwfHx8MA%3D%3D', // legal / documents
    'https://images.unsplash.com/photo-1560518883-ce09059eeffa?auto=format&fit=crop&w=1400&q=80', // relocation / new home
  ],
};

function VideoPlayer({ fileVideo, embedUrl, heroImage, serviceName }) {
  const videoRef = useRef(null);
  const [videoError, setVideoError] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isMuted, setIsMuted] = useState(false);

  const togglePlay = () => {
    const v = videoRef.current;
    if (!v) return;
    if (v.paused) { v.play(); } else { v.pause(); }
  };

  const toggleMute = () => {
    const v = videoRef.current;
    if (!v) return;
    v.muted = !v.muted;
    setIsMuted(v.muted);
  };

  if (!fileVideo && !embedUrl) {
    return (
      <div className="sd-video-placeholder" style={{ backgroundImage: `url(${heroImage})` }}>
        <div className="sd-video-placeholder-overlay" />
        <div className="sd-video-placeholder-body">
          <span className="sd-video-placeholder-icon material-symbols-outlined">play_circle</span>
          <span className="sd-video-placeholder-label">Video coming soon</span>
        </div>
      </div>
    );
  }

  if (embedUrl) {
    return (
      <div className="sd-embed-wrap">
        <iframe
          src={embedUrl}
          title={serviceName}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }

  return (
    <div className="sd-player">
      {videoError ? (
        <div className="sd-player-error">
          <span className="material-symbols-outlined">videocam_off</span>
        </div>
      ) : (
        <>
          <video
            ref={videoRef}
            src={fileVideo}
            className="sd-player-video"
            onError={() => setVideoError(true)}
            onEnded={() => setIsPlaying(false)}
            onPause={() => setIsPlaying(false)}
            onPlay={() => setIsPlaying(true)}
            playsInline
            preload="metadata"
          />
          <div className="sd-player-overlay">
            <button type="button" onClick={togglePlay} className="sd-player-big-btn" aria-label={isPlaying ? 'Pause' : 'Play'}>
              <span className="material-symbols-outlined">{isPlaying ? 'pause' : 'play_arrow'}</span>
            </button>
          </div>
          <div className="sd-player-bar">
            <button type="button" onClick={togglePlay} aria-label={isPlaying ? 'Pause' : 'Play'}>
              <span className="material-symbols-outlined">{isPlaying ? 'pause' : 'play_arrow'}</span>
            </button>
            <button type="button" onClick={toggleMute} aria-label={isMuted ? 'Unmute' : 'Mute'}>
              <span className="material-symbols-outlined">{isMuted ? 'volume_off' : 'volume_up'}</span>
            </button>
          </div>
          {!isPlaying && (
            <button type="button" onClick={togglePlay} className="sd-player-static" aria-label="Play">
              <div className="sd-player-static-icon">
                <span className="material-symbols-outlined">play_arrow</span>
              </div>
            </button>
          )}
        </>
      )}
    </div>
  );
}

function ServiceDetailPage() {
  const { serviceId } = useParams();
  const { t, isArabic } = useLanguage();

  const { service, serviceIndex, allServices } = useMemo(() => {
    const groups = t.servicesCatalog?.groups || [];
    const all = [];
    let idx = 0;
    let found = { service: null, serviceIndex: 0 };

    for (const group of groups) {
      for (const item of group.items) {
        all.push({ ...item, sIdx: idx });
        if (item.id === serviceId) {
          found = { service: item, serviceIndex: idx };
        }
        idx++;
      }
    }

    const sovereign = t.servicesCatalog?.sovereign;
    if (sovereign) {
      all.push({ ...sovereign, sIdx: idx });
      if (sovereign.id === serviceId) {
        found = { service: sovereign, serviceIndex: idx };
      }
    }

    return { ...found, allServices: all };
  }, [t, serviceId]);

  const heroImage = service?.image || SERVICE_CARD_IMAGES[serviceIndex] || SERVICE_CARD_IMAGES[0];
  const videoUrl = service?.videoUrl || null;
  const embedUrl = useMemo(() => getYouTubeEmbedUrl(videoUrl), [videoUrl]);
  const fileVideo = service?.detail?.videoSrc || service?.video || null;
  const overviewParagraphs = service?.detail?.details || (service?.marketing ? [service.marketing] : []);
  const detailCategories = service?.detail?.categories || [];
  const heroDesc = service?.detail?.heroDesc || service?.platformTitle || '';
  const otherServices = allServices.filter((s) => s.id !== serviceId).slice(0, 6);
  const dir = isArabic ? 'rtl' : 'ltr';

  if (!service) {
    return (
      <main className="inner-page" dir={dir}>
        <section className="container page-hero">
          <h1>Service not found</h1>
          <Link to="/services" className="sd-back-link">
            <span className="material-symbols-outlined" aria-hidden="true">arrow_back</span>
            {t.serviceDetail?.backLink || 'Back to services'}
          </Link>
        </section>
      </main>
    );
  }

  return (
    <main className="inner-page service-detail-page" dir={dir}>

      {/* Hero */}
      <section className="sd-hero" style={{ backgroundImage: `url(${heroImage})` }}>
        <div className="sd-hero-overlay" />
        <div className="container sd-hero-inner">
          <Link to="/services" className="sd-back-link">
            <span className="material-symbols-outlined" aria-hidden="true">
              {isArabic ? 'arrow_forward' : 'arrow_back'}
            </span>
            {t.serviceDetail.backLink}
          </Link>
          <div className="sd-hero-content">
            <h1 className="sd-hero-title">{service.name}</h1>
            <p className="sd-hero-subtitle">{heroDesc}</p>
          </div>
        </div>
      </section>

      {/* Intro + Video */}
      <section className="container sd-intro">
        <div className="sd-intro-grid">
          <Reveal direction={isArabic ? 'right' : 'left'}>
            <div className="sd-intro-text">
              {overviewParagraphs.map((para, i) => (
                <p key={i}>{para}</p>
              ))}
            </div>
          </Reveal>
          <Reveal direction={isArabic ? 'left' : 'right'}>
            <div className="sd-intro-media">
              <VideoPlayer
                fileVideo={fileVideo}
                embedUrl={embedUrl}
                heroImage={heroImage}
                serviceName={service.name}
              />
            </div>
          </Reveal>
        </div>
      </section>

      {/* Categories zigzag */}
      {detailCategories.length > 0 && (
        <section className="sd-cats">
          <Reveal>
            <div className="container sd-cats-heading">
              <h2 className="sd-cats-title">{t.serviceDetail?.detailsTitle || 'Service details'}</h2>
            </div>
          </Reveal>
          <div className="sd-cats-list">
            {detailCategories.map((category, idx) => {
              const reversed = idx % 2 !== 0;
              const serviceImgs = SERVICE_CATEGORY_IMAGES[serviceId] || DETAIL_FALLBACK_IMAGES;
              const image = category.image || serviceImgs[idx] || DETAIL_FALLBACK_IMAGES[idx % DETAIL_FALLBACK_IMAGES.length];
              return (
                <Reveal key={idx}>
                  <div className={`sd-cat-row ${reversed ? 'sd-cat-row-reverse' : ''}`}>
                    <div className="sd-cat-image-panel">
                      <img src={image} alt={category.title} className="sd-cat-img" />
                      <div className={`sd-cat-fade ${reversed ? 'sd-cat-fade-left' : 'sd-cat-fade-right'}`} />
                      <div className="sd-cat-num">{String(idx + 1).padStart(2, '0')}</div>
                    </div>
                    <div className="sd-cat-text-panel">
                      <div className="sd-cat-header">
                        <span className="sd-cat-icon">
                          <span className="material-symbols-outlined" aria-hidden="true">{category.icon}</span>
                        </span>
                        <h3 className="sd-cat-title">{category.title}</h3>
                      </div>
                      <ul className="sd-cat-services">
                        {category.services.map((item, sIdx) => (
                          <li key={sIdx} className="sd-cat-item">
                            <span className="sd-cat-check" aria-hidden="true">
                              <span className="material-symbols-outlined">check</span>
                            </span>
                            <div className="sd-cat-item-body">
                              <strong>{item.name}</strong>
                              <span>{item.desc}</span>
                            </div>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </section>
      )}

      {/* Other services */}
      {otherServices.length > 0 && (
        <section className="container sd-other">
          <Reveal>
            <h2 className="sd-other-heading">
              {t.serviceDetail?.otherServices || 'Other services'}
            </h2>
          </Reveal>
          <div className="sd-other-grid">
            {otherServices.map((s, i) => {
              const img = s.image || SERVICE_CARD_IMAGES[s.sIdx] || SERVICE_CARD_IMAGES[0];
              return (
                <Reveal key={s.id} delay={i * 50}>
                  <Link to={`/services/${s.id}`} className="sd-other-card">
                    <img src={img} alt={s.name} className="sd-other-img" />
                    <div className="sd-other-overlay" />
                    <div className="sd-other-body">
                      <span className="sd-other-name">{s.name}</span>
                    </div>
                  </Link>
                </Reveal>
              );
            })}
          </div>
        </section>
      )}
    </main>
  );
}

export default ServiceDetailPage;
